import { useState } from 'react'

const usePayModal = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [message, setMessage] = useState('')

  const showPay = (msg) => {
    setMessage(msg)
    setIsVisible(true)
  }

  const closeError = () => {
    setIsVisible(false)
    setMessage('')
  }

  return { isVisible, message, showPay, closeError }
}

export default usePayModal
